<div class="confirm-dialog" [ngClass]="'confirm-dialog--' + tone">
  <div class="confirm-dialog__hero">
    <span class="confirm-dialog__icon" [innerHTML]="toneIcon"></span>

    <div class="confirm-dialog__copy">
      <span class="confirm-dialog__eyebrow">Megerősítés</span>
      <h2>{{data.title}}</h2>
      <p>{{data.message}}</p>
      <p class="confirm-dialog__details" *ngIf="data.details">{{data.details}}</p>
    </div>
  </div>

  <label class="confirm-dialog__checkbox" *ngIf="data.checkboxLabel">
    <input type="checkbox" [(ngModel)]="checkboxChecked" />
    <span>{{data.checkboxLabel}}</span>
  </label>

  <label class="confirm-dialog__checkbox" *ngIf="data.secondaryCheckboxLabel">
    <input type="checkbox" [(ngModel)]="secondaryCheckboxChecked" />
    <span>{{data.secondaryCheckboxLabel}}</span>
  </label>

  <div class="confirm-dialog__actions">
    <button type="button" class="confirm-dialog__button confirm-dialog__button--ghost" (click)="cancel()">
      {{cancelLabel}}
    </button>
    <button type="button" class="confirm-dialog__button confirm-dialog__button--confirm" (click)="confirm()">
      {{confirmLabel}}
    </button>
  </div>
</div>
